
function create_tooltip(){
	
//For Special Notes Tooltip	
	$("img.special-notes").each(
	function(){
		$(this).qtip({
		content: $("#tooltip_"+ $(this).attr('id')).html(),
		show: { when: 'click', delay:10 },
		hide: { when: 'unfocus', fixed: false },
		style: { 
			name: 'dark' ,// Inherit from preset style
			background: '#1d4f8d',
			textAlign: 'center',
			padding:'3px 5px',
			border: { color: '#a6a8ab',  width: 2 },
			tip: { 
			corner: 'bottomMiddle', 
			size: {
            	x: 10, 
            	y : 8 
         	}
		} 
   },
		position: {
			corner: {
				target: 'topMiddle',
				tooltip: 'bottomMiddle'
      		}
   		}

	});
});


	$(".poi").on('focus mouseover touchstart', function(e) {
		e.preventDefault();
		$(this).qtip({
			content : $(this).children().attr('alt'),
			show: {
				solo: true,
				ready: true
			},
			hide: {
				fixed: false
			},
			style: { 
				name: 'dark' ,// Inherit from preset style
				background: '#AD3500',
				textAlign: 'center',
				padding:'3px 5px',
				border: { color: '#AD3500',  width: 2 },
				tip: { 
					corner: 'bottomMiddle', 
					size: {
						x: 10, 
						y : 8 
					}
				} 
			},
			position: {
				corner: {
					target: 'topMiddle',
					tooltip: 'bottomMiddle'
				}
			}
		})
	});

	$(".activity-icons").on('focus mouseover', function() {
		$(this).qtip({
			content: $(this).attr('data-qtip-content'),
			show: {
				solo: true,
				ready: true
			},
			hide: {
				fixed: false
			},
			style: { 
				name: 'dark' ,
				background: '#333333',
				textAlign: 'center',
				padding:'2px 5px',
				lineHeight:'12px',
				border: { color: '#a6a8ab',  width: 1, radius: 2  },
				tip: { 
				corner: 'bottomMiddle',
				size: {
	            	x: 10,
	            	y : 8
	         	}
			} 
	   },
			position: {
				corner: {
					target: 'topMiddle',
					tooltip: 'bottomMiddle'
	      		}
	   		}

		})
	});

}

$(document).ready(function() {
	create_tooltip();
});